export default __webpack_public_path__ + "static/media/CTO.d60cc514.PNG";